import { PersonName } from '@occc/graphql';

export const getPersonFullName = (name: PersonName | undefined | null): string | null => {
  if (!name) {
    return null;
  }

  const personFullName = `${name.first || ''} ${name.last || ''}`;

  return personFullName.trim();
};
